import { ApplicationConfig, provideZoneChangeDetection } from "@angular/core";
import { provideRouter } from "@angular/router";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { CalAngularModule } from "@cvx/cal-angular";
import { routes } from "./app.routes";
import { errorInterceptor } from "./interceptors/error.interceptor";
import { authInterceptor } from "./interceptors/auth.interceptor";
import { environment } from "../environments/environment";

// Define the CAL config object
const calConfig = {
  autoSignIn: false,
  popupForLogin: false,
  cacheLocation: "localStorage",
  instance: "https://login.microsoftonline.com/",
  tenantId: environment.calTenantId,
  clientId: environment.calClientId,
  redirectUri: (() => {
    const url = new URL(window.location.href);
    const port = !!url.port ? `:${url.port}` : "";
    return `${url.protocol}//${url.hostname}${port}`;
  })(),
  oidcScopes: ["openid", "profile", "User.Read", "offline_access"],
  graphScopes: [".default"]
};

// Get providers from CalAngularModule.forRoot()
const calAngularProviders = CalAngularModule.forRoot(calConfig).providers || [];

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor])),
    { provide: Window, useValue: window },
    ...calAngularProviders
  ],
};
